import React, { Component, PropTypes } from 'react';
import { Badge, Menu, Icon, Table, Button, Modal, Spin, Row, Col, Select, Input, Pagination, Form, InputNumber } from 'antd';
import { browserHistory, Link } from 'react-router';
import _ from 'lodash';
import cn from 'classnames';
import { formatRating } from 'utils/formatting';

import { formItemLayout } from 'constants/layout';

import { connect } from 'react-redux';
import { getCategories } from 'data/category';

import { TableHelper, exportAsExcel } from 'helpers/Table';
import { getClassList, getAllClasses, recommendClass, unrecommendClass, updateClassById } from 'data/class'; // recommendClass, unrecommendClass, updateClassById
import Utils from 'utils/utils';
import moment from 'moment';
import { formatNumber } from 'utils/formatting';
// import Utils from 'utils/utils';
import classes from '../styles/class/ClassList.module.scss';

import COLUMNS from './ClassListColumns.js';
import ComFeeModal from './ComFeeModal';

// const SubMenu = Menu.SubMenu;
// const MenuItemGroup = Menu.ItemGroup;
const FormItem = Form.Item;
const pageLimit = 20;
const Confirm = Modal.confirm;
const Option = Select.Option;

const formatPrice = (number) => {
  return formatNumber(number, '0,0.00');
};
// @asyncConnect([
//   {
//     promise: ({ store: { dispatch }, location: { query } }) => {
//       const promises = [];
//       promises.push(dispatch(getClassList(query)));
//       promises.push(dispatch(getCategories()));

//       return Promise.all(promises);
//     },
//   },
// ])

class ClassList extends Component {
  constructor(props) {
    super(props);
    this.changeFocusPage = this.changeFocusPage.bind(this);
    this.onChangePage = this.onChangePage.bind(this);
    this.onSearch = this.onSearch.bind(this);
    this.onInputSearch = this.onInputSearch.bind(this);
    this.onSearchInputPress = this.onSearchInputPress.bind(this);
    this.changeCategory = this.changeCategory.bind(this);
    this.changeSubcategory = this.changeSubcategory.bind(this);
    this.changeType = this.changeType.bind(this);
    this.onTableChange = this.onTableChange.bind(this);
    this.onRecommendClass = this.onRecommendClass.bind(this);
    this.onUnrecommendClass = this.onUnrecommendClass.bind(this);

    this.state = {
      collapseMobile: [],
      isShowOrderModal: false,
      page: props.page,
      displaySearchValue: '',
      updatedOrders: {},
      selectedRowKeys: [],
      classes: [],
      categories: [],
      ...props.location.query,
      sortBy: props.location.query.sortBy ? props.location.query.sortBy : undefined,
      searchValue: props.location.query.q ? props.location.query.q : '',
      selectedStatus: props.location.query.status ? props.location.query.status : 'all',
      selectedCategory: props.location.query.category ? props.location.query.category : 'all',
      selectedSubcategory: props.location.query.subcategory ? props.location.query.subcategory : 'all',
      selectedType: props.location.query.type ? props.location.query.type : 'all',
      page: props.location.query.page ? parseInt(props.location.query.page, 10) : 1,
      loading: false,
    };
  }

  componentDidMount = async () => {
    const classes = await getClassList(this.props.location.query);
    const categories = await getCategories();

    const updatedOrders = classes.results.reduce((result, tpClass) => {
      result[tpClass._id] = tpClass.recommendedOrder;
      return result;
    }, {});
    this.setState({
      classes: classes.results,
      page: classes.currentPage,
      classCount: classes.count,
      categories: categories,
      updatedOrders,
    });
  };

  componentWillMount() {
    this.setState({
      isShowOrderModal: false,
    });
  }

  componentWillReceiveProps(props, xprops) {
    const updatedOrders = this.state.classes.reduce((result, tpClass) => {
      result[tpClass._id] = tpClass.recommendedOrder;
      return result;
    }, {});
    this.setState({
      ...props.location.query,
      sortBy: props.location.query.sortBy ? props.location.query.sortBy : undefined,
      searchValue: props.location.query.q ? props.location.query.q : '',
      selectedStatus: props.location.query.status ? props.location.query.status : 'all',
      selectedCategory: props.location.query.category ? props.location.query.category : 'all',
      selectedSubcategory: props.location.query.subcategory ? props.location.query.subcategory : 'all',
      selectedType: props.location.query.type ? props.location.query.type : 'all',
      page: props.location.query.page ? parseInt(props.location.query.page, 10) : 1,
      updatedOrders,
    });
  }

  onOpenOrderedModal = (record) => {
    this.setState({
      selectedClassroom: record,
      isShowOrderModal: true,
    });
  };

  onChangePage(page) {
    this.setState(
      {
        page,
      },
      () => {
        console.log(page);
        this.getClassList(_.merge(this.getCurrentQuery(), { page }));
      },
    );
  }

  onSearch() {
    this.setState({
      page: 1,
      searchValue: this.state.displaySearchValue,
      loading: true,
    });
    this.getClassList(_.merge(this.getCurrentQuery(), { q: this.state.displaySearchValue, page: 1 })).then((response) => {
      console.log(response);
      this.setState({ loading: false });
    });
  }

  onInputSearch(event) {
    this.setState({
      displaySearchValue: event.target.value,
    });
  }

  onSearchInputPress(event) {
    if (event.charCode === 13) {
      this.onSearch();
    }
  }

  onTableChange(a, b, sorter) {
    const { field, order } = sorter;
    if (order === 'descend') {
      this.setState({ sortBy: `-${field}` }, this.onSearch);
    } else if (order === 'ascend') {
      this.setState({ sortBy: field }, this.onSearch);
    }
  }
  onRecommendClass(_id) {
    recommendClass(_id).then(() => this.getClassList(this.getCurrentQuery()));
  }

  onUnrecommendClass(_id) {
    unrecommendClass(_id).then(() => this.getClassList(this.getCurrentQuery()));
  }

  getClassList = async (query) => {
    browserHistory.push(`${this.props.location.pathname}${Utils.createQueryString(query)}`);
    this.setState({
      loading: true,
    });
    const classes = await getClassList(query);
    const updatedOrders = classes.results.reduce((result, tpClass) => {
      result[tpClass._id] = tpClass.recommendedOrder;
      return result;
    }, {});
    this.setState({
      classes: classes.results,
      page: classes.currentPage,
      classCount: classes.count,
      updatedOrders,
      loading: false,
    });
    return Promise.resolve();
  };

  getCurrentQuery() {
    return {
      page: this.state.page,
      status: this.state.selectedStatus,
      category: this.state.selectedCategory,
      subcategory: this.state.selectedSubcategory,
      type: this.state.selectedType,
      q: this.state.searchValue,
      sortBy: this.state.sortBy,
    };
  }

  handleEditRemark = () => {
    const selectedClassroom = this.state.selectedClassroom;
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        if (values.recommendedOrder || values.recommendedOrder === 0) {
          updateClassById(selectedClassroom._id, { recommendedOrder: values.recommendedOrder })
            .then(() => {
              return this.getClassList(this.getCurrentQuery());
            })
            .then(() => {
              this.setState({ isShowOrderModal: false });
            });
        }
        console.log('Received values of form: ', values);
      }
    });
  };

  changeCategory(category) {
    this.setState({
      selectedCategory: category,
      selectedSubcategory: 'all',
    });
  }

  changeSubcategory(subcategory) {
    this.setState({
      selectedSubcategory: subcategory,
    });
  }

  changeType(type) {
    this.setState({
      selectedType: type,
    });
    // console.log(event);
  }

  changeFocusPage(event) {
    const status = event.key;
    this.setState({
      selectedStatus: status,
      selectedRowKeys: [],
      page: 1,
    });
    this.getClassList(_.merge(this.getCurrentQuery(), { status, page: 1 })).then((response) => {
      console.log(response);
    });
  }

  showDeleteConfirm(record, msg, content) {
    Confirm({
      title: msg,
      content: content || '',
      onOk: () => this.onDelete(record),
      onCancel: this.onCancel,
    });
  }

  saveClassesOrder = () => {
    if (_.isEmpty(this.state.updatedOrders)) {
      return;
    }
    let timeout = 0;
    let index = 0;
    let orderCount = 0;
    this.props.showWaiting();
    _.forEach(this.state.updatedOrders, (value, key) => {
      orderCount++;
      setTimeout(() => {
        this.props.updateClassById(key, { recommendedOrder: value }).then(() => {
          index++;
          if (index === orderCount) {
            this.getClassList(this.getCurrentQuery()).then(() => this.props.hideWaiting());
          }
        });
      }, timeout);
      timeout += 300;
    });
  };

  exportToExcel = async () => {
    const resultObj = await getAllClasses(this.getCurrentQuery());
    const results = resultObj.results;
    const content = results.map((singleContent, key) => {
      singleContent.key = key;
      return singleContent;
    });
    const selectedStatusColumn = _.get(_.find(this.classStatuses, { value: this.state.selectedStatus }), 'column');
    let columns = COLUMNS[selectedStatusColumn].map((colName) => {
      const col = _.find(this.columns, { columnName: colName });
      return col;
    });
    columns = _.compact(columns);
    exportAsExcel({
      filename: `CLASSES-${moment().format('DD-MM-YYYY_HH-mm-ss')}.xlsx`,
      sheetName: 'Sheet1',
      columns,
      data: content,
    });
  };
  columns = [
    {
      ...TableHelper.defaultColumn('No.', 'classCode'),
      render: (value, record) => (
        <div className="no-wrap">
          <Link to={`/class/${record._id}`}>{value} </Link>
          {record.remark && <Icon type="pushpin" />}
        </div>
      ),
      width: '100px',
      sorter: true,
    },
    {
      ...TableHelper.defaultColumn('Title', 'name'),
      render: (value, record) => {
        if (record.classType !== 'flexible') {
          return <span>{value}</span>;
        }
        const reqCount = record.requestedCount;
        let link;
        if (_.get(record, 'upcomingSchedules[0]')) {
          link = `/class/${record._id}/schedule/${_.get(record, 'upcomingSchedules[0]._id')}/offering?selectedTab=request`;
        } else {
          link = `/class/${record._id}`;
        }
        return (
          <span>
            {value}
            <Link to={link}>
              <Badge className={'noti-container'} count={reqCount} showZero />
            </Link>
          </span>
        );
      },
      width: '250px',
    },
    {
      ...TableHelper.defaultColumn('Teacher', 'owner.displayName'),
      width: '150px',
      render: (value, record) => {
        const isVerified = _.get(record, 'owner.verified');
        return (
          <div>
            <Link to={`/teacher/${record.owner ? record.owner._id : ''}`}>{value}</Link> &nbsp;
            {isVerified && <Icon type="check-circle" className="text-primary" />}
          </div>
        );
      },
    },
    {
      ...TableHelper.dateColumn('Create date', 'createdAt'),
      width: '120px',
      sorter: true,
    },
    {
      ...TableHelper.dateColumn('Last update', 'updatedAt'),
      width: '120px',
      sorter: true,
    },
    {
      ...TableHelper.dateColumn('Reject date', 'rejectedDate'),
      width: '120px',
      sorter: true,
    },
    {
      ...TableHelper.dateColumn('Close date', 'closedDate'),
      width: '120px',
      sorter: true,
    },

    {
      ...TableHelper.defaultColumn('Status', 'status'),
      width: '100px',
      render: (value) => _.startCase(value),
    },
    {
      ...TableHelper.defaultColumn('Recommend', 'isRecommended'),
      width: '90px',
      render: (value) => {
        const element = value ? <Icon type="check" className="fa-2x text-success" /> : null;
        return element;
      },
    },
    {
      ...TableHelper.integerColumn('View', 'view'),
      width: '90px',
      sorter: true,
    },
    {
      ...TableHelper.integerColumn('Students', 'graduatedStudentCount'),
      width: '100px',
      sorter: true,
    },
    {
      ...TableHelper.integerColumn('Reviews', 'ratings.averageRatings'),
      width: '100px',
      render: (value, record) => {
        return `${formatRating(value)} (${record.reviewCount})` || 0;
      },
      renderExcel: (value, record) => {
        return `${formatRating(value)} (${record.reviewCount})` || 0;
      },
      sorter: true,
    },
    {
      columnName: 'recommendedOrder',
      title: 'Order',
      dataIndex: 'recommendedOrder',
      width: '150px',
      render: (value, record) => {
        const updatedState = _.get(this.state, `updatedOrders.${record._id}`);
        console.log(updatedState);
        return (
          <div>
            <InputNumber
              onChange={(inputValue) => {
                this.setState({ updatedOrders: { ...this.state.updatedOrders, [record._id]: inputValue || 0 } });
              }}
              value={updatedState}
            />
            {/* {value || 0}{' '}
            <a onClick={() => this.onOpenOrderedModal(record)}>
              <Icon type="edit" />
            </a> */}
          </div>
        );
      },
      sorter: true,
      renderExcel: (value) => value,
    },
    {
      ...TableHelper.defaultColumn('Reject reason', 'rejectMessage'),
      width: '200px',
      render: (value) => {
        return <div dangerouslySetInnerHTML={{ __html: value }} />;
      },
    },
    {
      columnName: 'command',
      title: '',
      dataIndex: '',
      width: '80px',
      render: (value, record) => {
        const _id = _.get(record, '_id');
        const isRecommended = record.isRecommended;
        const element = isRecommended ? (
          <Icon onClick={() => this.onUnrecommendClass(_id)} type="star" className="text-warning pointer" />
        ) : (
          <Icon type="star-o" onClick={() => this.onRecommendClass(_id)} className="pointer" />
        );

        return (
          <div>
            {record.status === 'approved' && element}
            {' | '}
            <Link to={`/class/${record._id}?selectedTab=schedules`}>
              <Icon type="schedule" className={classes.commandIcon} />
            </Link>
          </div>
        );
      },
    },
  ];

  classStatuses = [
    { label: 'All', value: 'all', column: 'all' },
    { label: 'Recommended', value: 'recommend', column: 'recommended' },
    { label: 'Approved', value: 'approved', column: 'approved' },
    { label: 'Pending', value: 'pending', column: 'pending' },
    { label: 'Rejected', value: 'rejected', column: 'rejected' },
    { label: 'Closed', value: 'closed', column: 'closed' },
  ];

  renderPageTopMenu() {
    return (
      <Menu onClick={this.changeFocusPage} selectedKeys={[this.state.selectedStatus]} mode="horizontal" className={classes.menu}>
        {this.classStatuses &&
          this.classStatuses.map((singleClass) => (
            <Menu.Item key={singleClass.value} className={classes.dashRight}>
              <div>{singleClass.label} </div>
            </Menu.Item>
          ))}
      </Menu>
    );
  }

  renderContentTable() {
    const content = _.map(this.state.classes, (singleContent, key) => {
      singleContent.key = key;
      return singleContent;
    });
    const selectedStatusColumn = _.get(_.find(this.classStatuses, { value: this.state.selectedStatus }), 'column');
    let columns = COLUMNS[selectedStatusColumn].map((colName) => {
      const col = _.find(this.columns, { columnName: colName });
      return col;
    });
    columns = _.compact(columns);
    const { selectedRowKeys } = this.state;
    // const rowSelection = {
    //   selectedRowKeys,
    //   onChange: this.onRowSelectChange,
    //   hideDefaultSelections: true,
    // };

    return (
      <div>
        <Table columns={columns} dataSource={content} bordered pagination={false} onRowClick={this.onClickRow} onChange={this.onTableChange} scroll={{ x: 1400 }} />
        <Pagination className={cn(classes.pagination, 'text-right')} current={this.state.page} onChange={this.onChangePage} defaultPageSize={pageLimit} total={this.state.classCount} />
      </div>
    );
  }

  renderEditRemarkModal() {
    const { getFieldDecorator } = this.props.form;
    if (!this.state.isShowOrderModal) {
      return <div />;
    }
    const selectedClassroom = this.state.selectedClassroom;

    return (
      <Modal
        title={'Class Order'}
        visible={this.state.isShowOrderModal}
        onCancel={() => this.setState({ isShowOrderModal: false })}
        footer={[
          <Button key="submit" type="primary" size="large" loading={this.state.loading} onClick={this.handleEditRemark}>
            Save
          </Button>,
          <Button key="back" size="large" onClick={this.props.handleCancel}>
            Cancel
          </Button>,
        ]}
      >
        <Form onSubmit={this.handleEditRemark}>
          <FormItem {...formItemLayout} label="Order">
            {getFieldDecorator('recommendedOrder', {
              initialValue: selectedClassroom.recommendedOrder,
            })(<InputNumber />)}
          </FormItem>
        </Form>
      </Modal>
    );
  }

  render() {
    const { classesLoading } = this.props;
    const categories = this.state.categories;
    let subcategories = [];
    if (this.state.selectedCategory !== 'all') {
      const category = _.find(categories, { _id: this.state.selectedCategory });
      subcategories = category.subcategories;
    }
    return (
      <div>
        <div className="page-header">{this.props.BreadCrumb}</div>
        <div className="content">
          <Spin tip="Loading" size="large" spinning={!!this.state.loading}>
            {this.renderPageTopMenu()}
            <div className={classes.searchContainer}>
              <Row>
                <Col xs={5}>
                  <Input prefix={<Icon type="search" />} placeholder="Search" onKeyPress={(e) => this.onSearchInputPress(e)} onChange={(e) => this.onInputSearch(e)} />
                </Col>
                <Col xs={3}>
                  <Select defaultValue="all" onChange={this.changeCategory} style={{ width: '100%', paddingLeft: 10 }} size="large">
                    <Option value="all">หมวดหมู่ทั้งหมด</Option>
                    {categories.map((category) => (
                      <Option value={category._id}>{category.name}</Option>
                    ))}
                  </Select>
                </Col>
                <Col xs={3}>
                  <Select defaultValue="all" onChange={this.changeSubcategory} style={{ width: '100%', paddingLeft: 10 }} size="large" value={this.state.selectedSubcategory}>
                    <Option value="all">หมวดหมู่ย่อยทั้งหมด</Option>
                    {subcategories.map((subcategory) => (
                      <Option value={subcategory._id}>{subcategory.name}</Option>
                    ))}
                  </Select>
                </Col>

                <Col xs={3}>
                  <Button className="search-btn" onClick={this.onSearch}>
                    <Icon type="search" />
                  </Button>
                </Col>
              </Row>
            </div>
            {this.state.selectedStatus === 'recommend' && (
              <div className={classes.saveOrderBtnContainer}>
                <Button type="success" onClick={() => this.saveClassesOrder()}>
                  Save Order
                </Button>
              </div>
            )}

            <div className="text-right">
              <a onClick={() => this.exportToExcel()}>
                <Icon type="file-excel" /> Export to excel
              </a>
            </div>

            {this.renderContentTable()}
          </Spin>
        </div>
        {this.renderEditRemarkModal()}
        <ComFeeModal
          setIsOpen={(status) => this.setState({ isFeeModalOpen: status })}
          isOpen={this.state.isFeeModalOpen}
          classroom={this.state.selectedClassroom}
          reload={() => this.getClassList(this.getCurrentQuery())}
        ></ComFeeModal>
      </div>
    );
  }
}
export default connect(
  (state) => ({
    // pages: state.content.pages,
    // classesLoading: state.classroom.classListWaiting,
    // classes: state.classroom.classList.results,
    // page: state.classroom.classList.currentPage,
    // classCount: state.classroom.classList.count,
    // categories: state.category.categories,
  }),
  {
    // getClassList, getAllClasses, recommendClass, unrecommendClass, updateClassById, showWaiting, hideWaiting
  },
)(Form.create()(ClassList));
